<template>
  <div>
    <div id="wrapper">
      <img src="../assets/my/2025.png" style="height:120px;"/>
    		<div id="content" style="height:690px;">
    			<p style="font-size:large; float:none;">
    				<strong>
    				    Key Dates
    				</strong>
    			</p>

                <table width="100%" border="0" cellspacing="4" cellpadding="0">
                    <tr>
                        <td>&nbsp;</td>
                      </tr>
                    <tr>
                      <span class="my-c">Due&nbsp;date&nbsp;for&nbsp;full&nbsp;workshop&nbsp;papers&nbsp;submission:</span>
                    </tr>
                    <tr>
                      <!-- <span class="my-c">October&nbsp;15,&nbsp;2025</span> -->
                              <span class="my-c">October&nbsp;<span style="text-decoration: line-through; color: red;">15</span><span >25</span>,&nbsp;2025</span>

                    </tr>
                    <tr>
                        <td>&nbsp;</td>
                      </tr>
                    <tr>
                      <span class="my-c">Notification&nbsp;of&nbsp;paper&nbsp;acceptance&nbsp;to&nbsp;authors:</span>
                    </tr>
                    <tr>
                      <span class="my-c">November&nbsp;15,2025</span>
                    </tr>
                    <tr>
                        <td>&nbsp;</td>
                      </tr>
                    <tr>
                      <span class="my-c">Camera-ready&nbsp;of&nbsp;accepted&nbsp;papers:</span>
                    </tr>
                    <tr>
                      <span class="my-c">November&nbsp;23,2025</span>
                        <td>&nbsp;</td>
                      </tr>
                      <tr>
                          <td>&nbsp;</td>
                        </tr>
                    <tr>
                      <span class="my-c">Workshop&nbsp;date:</span>
                    </tr>

                    <tr>
                      <span class="my-c">December&nbsp;
                      <span style="text-decoration: line-through; color: red;">16</span><span >15</span>,2025
                      
                      </span>
                    </tr>
                </table>



    		</div>
    	</div>
      <footer-component></footer-component>
  </div>
</template>

<script>
  import FooterComponent from '@/components/Foot/footer.vue'

  export default {
    components: {
      FooterComponent
    }
  }
</script>

<style>
  .crossed-number {
    position: relative;
  }

  .crossed-number::before {
    content: "";
    position: absolute;
    top: 50%;
    left: 0;
    right: 0;
    height: 2px;
    background-color: red; /* 划线颜色 */
    transform: translateY(-50%);
    z-index: 1;
  }
</style>
